import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserCdnRepository } from '../../repositories/interfaces/iUserCdnRepository';
import { UserRevision } from '../../entities/UserRevision';

export interface IGetUserRevisionUseCase {
    execute(bucketId: number): Promise<UserRevision>;
}

export class GetUserRevisionUseCase implements IGetUserRevisionUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userCdnRepository(): IUserCdnRepository {
        return container.resolve<IUserCdnRepository>(DI.REPOSITORIES.IUserCdnRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(bucketId: number): Promise<UserRevision> {
        return this.userCdnRepository.getUserRevision(bucketId);
    }
}
